import React from 'react';
import { FaCheckCircle, FaShieldAlt, FaMobileAlt, FaArrowRight } from 'react-icons/fa';

const SuccessBanner = ({ 
  title = "Verification Complete!",
  subtitle = "Your phone number has been successfully verified",
  phoneNumber = "",
  onContinue = null,
  continueText = "Continue to Dashboard",
  className = ""
}) => {
  return (
    <div className={`text-center mb-8 ${className}`}>
      {/* Success Icon with Animation */}
      <div className="relative mb-6">
        <div className="inline-flex items-center justify-center w-20 h-20 bg-gradient-to-br from-green-500 to-green-600 rounded-full mb-4 shadow-lg animate-bounce">
          <FaCheckCircle className="text-white text-3xl" />
        </div>
        
        {/* Celebration Rings */}
        <div className="absolute inset-0 w-20 h-20 rounded-full border-4 border-green-300 opacity-30 animate-ping" />
        <div className="absolute inset-0 w-20 h-20 rounded-full border-2 border-green-200 opacity-50 animate-pulse" />
        <div className="absolute inset-0 w-20 h-20 rounded-full border border-green-100 opacity-70 animate-ping" style={{ animationDelay: '0.5s' }} />
      </div>

      {/* Success Title */}
      <h2 className="text-3xl md:text-4xl font-bold text-green-700 dark:text-green-400 mb-3">
        {title}
      </h2>

      {/* Success Subtitle */}
      <p className="text-base text-gray-600 dark:text-gray-400 mb-6 max-w-md mx-auto leading-relaxed">
        {subtitle}
      </p>

      {/* Verification Details */}
      <div className="bg-green-50 dark:bg-green-900/20 border border-green-200 dark:border-green-800 rounded-xl p-6 mb-6">
        <div className="flex items-center justify-center gap-4 mb-4">
          <div className="flex items-center justify-center w-12 h-12 bg-green-100 dark:bg-green-800 rounded-full">
            <FaMobileAlt className="text-green-600 dark:text-green-400 text-xl" />
          </div>
          <div className="text-left">
            <p className="text-sm font-medium text-green-700 dark:text-green-300">
              Phone Number Verified
            </p>
            {phoneNumber && (
              <p className="text-sm text-green-600 dark:text-green-400 font-mono">
                {phoneNumber}
              </p>
            )}
          </div>
        </div>
        
        {/* Security Features */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3 text-left">
          <div className="flex items-center gap-2 text-xs text-green-600 dark:text-green-400">
            <FaShieldAlt className="h-3 w-3" />
            <span>Two-factor authentication enabled</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-green-600 dark:text-green-400">
            <FaCheckCircle className="h-3 w-3" />
            <span>Account security enhanced</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-green-600 dark:text-green-400">
            <FaMobileAlt className="h-3 w-3" />
            <span>Quick password recovery</span>
          </div>
          <div className="flex items-center gap-2 text-xs text-green-600 dark:text-green-400">
            <FaShieldAlt className="h-3 w-3" />
            <span>Important notifications</span>
          </div>
        </div>
      </div>

      {/* Continue Button */}
      {onContinue && (
        <button
          onClick={onContinue}
          className="group inline-flex items-center gap-3 px-8 py-4 bg-gradient-to-r from-green-500 to-green-600 text-white font-semibold rounded-xl hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl"
        >
          <span>{continueText}</span>
          <FaArrowRight className="group-hover:translate-x-1 transition-transform" />
        </button>
      )}

      {/* Success Message */}
      <div className="mt-6 text-sm text-gray-500 dark:text-gray-400">
        <p>🎉 Welcome to the secure side of iForge!</p>
      </div>
    </div>
  );
};

export default SuccessBanner; 